<template>
	<div class="triangle-rewards-card">
		<template v-if="handleOffersView">
			<div class="content">
				<img :alt="content.offers.rewards" :src="topPicksLogo" class="logo" />
			</div>
		</template>
		<template v-else-if="handleDisplayRewardsView">
			<div class="content rewards_signin">
				<div :class="layoutClass">
					<img :alt="content.offers.rewards" :src="joinLogo" />
					<div class="cta">
						<div class="cta-title">
							<h1>{{ content.offers.rewards_title_pre }}</h1>
							<h1>{{ content.offers.rewards_title_post }} <span class="registered-trademark">{{ content.offers.registered_trademark }}</span></h1>
							<h2 v-if="content.offers.rewards_title_en">{{ content.offers.rewards_title_en }}</h2>
						</div>
						<div class="cta-content">
							<div class="cta-body">
								<p>{{ content.offers.rewards_text_pre }}</p>
								<p>{{ content.offers.rewards_text_post }}</p>
								<p v-if="content.offers.rewards_text_post_en" class="rewards_text_post_en">{{ content.offers.rewards_text_post_en }}</p>
							</div>
							<button class="cta-button" @click="openTriangleSignIn" v-if="!isLoggedIntoCT">{{ content.offers.signin }}</button>
							<div class="cta-join">
								<div v-if="language === 'fr'">
									<p class="click_to_join">{{ content.offers.click_to_join }}<a :href="registrationUrl" target="_blank">{{ content.offers.join }}</a></p>
									<p class="click_to_join_en" v-if="content.offers.click_to_join_en">{{ content.offers.click_to_join_en }}<a :href="registrationUrl" target="_blank">{{ content.offers.join_en }}</a></p>
								</div>
								<div v-else>
									<p>{{ content.offers.click_to_join }}<a :href="registrationUrl" target="_blank">{{ content.offers.join }}</a></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import blockElementMixin from "@/mixins/blockElementMixin";

const GRID_ROW_HEIGHT_PX = 193.5;
const NO_OFFERS_GRID_ROW_COUNT = 3;
const SELECTOR_MOBILE_SECTION = "[mode=mobile] [page-id=triangleRewards].section-container";
const SELECTOR_BLOCK_NO_OFFERS = ".flyer-block.TriangleRewardsCard.noOffers";
const SELECTOR_BLOCK_WITH_OFFERS = ".flyer-block.TriangleRewardsCard:not(.noOffers)";

export default {
	name: "TriangleRewardsCard",
	mixins: [blockElementMixin],

	created() {
		this.loadOffers();
		this.updateBlockClass();
	},

	mounted() {
		this.$nextTick(() => this.applyMobileGridLayout());
		window.addEventListener("resize", this.applyMobileGridLayout);
	},

	beforeUnmount() {
		window.removeEventListener("resize", this.applyMobileGridLayout);
	},

	computed: {
		...mapGetters("ctUser", [
			"canViewTriangleRewards",
			"isSignedIn",
			"offerViewMode",
			"hasOffers",
			"isLoggedIntoCT",
			"hasTriangleID",
			"registrationUrl",
			"triangleSignInUrl",
			"triangleOffers"
		]),
		...mapGetters(["content", "language"]),
		...mapGetters("screen", ["displayMode", "flyerOrientation"]),

		isTuesday() {
			return new Date().getDay() === 2;
		},

		isPreviewFlyer() {
			return this.isLoggedIntoCT && this.hasTriangleID && this.offerViewMode === "preview";
		},

		handleOffersView() {
			return this.isLoggedIntoCT && this.hasTriangleID && this.offerViewMode === "live";
		},

		handleDisplayRewardsView() {
			return (
				(!this.isLoggedIntoCT && !this.hasTriangleID) ||
				(this.isLoggedIntoCT && !this.hasTriangleID) ||
				this.isPreviewFlyer ||
				(this.isPreviewFlyer && this.isTuesday) ||
				(!this.isLoggedIntoCT && this.hasTriangleID)
			);
		},

		layoutClass() {
			return `${this.language} ${this.flyerOrientation} ${this.displayMode}`;
		},

		topPicksLogo() {
			const isMobileVertical = this.displayMode === "mobile" && this.flyerOrientation === "vertical";
			return isMobileVertical
				? this.content.offers.top_picks_logo_vertical
				: this.content.offers.top_picks_logo;
		},

		joinLogo() {
			const isMobileVertical = this.displayMode === "mobile" && this.flyerOrientation === "vertical";
			return isMobileVertical
				? this.content.offers.join_logo_vertical
				: this.content.offers.join_logo;
		}
	},

	watch: {
		hasOffers() {
			this.updateBlockClass();
			this.$nextTick(() => this.applyMobileGridLayout());
		},
		triangleOffers() {
			this.$nextTick(() => this.applyMobileGridLayout());
		}
	},

	methods: {
		...mapActions("ctUser", ["triggerUserDialog", "updateOfferBlocks", "loadOffers"]),

		openTriangleSignIn() {
			window.open(this.triangleSignInUrl, "_blank");
		},

		updateBlockClass() {
			this.$set(this.block.classes, "noOffers", !this.hasOffers);
			this.$set(this.block.classes, "previewFlyer", this.isPreviewFlyer);
		},

		applyMobileGridLayout() {
			const noOffersBlock = document.querySelector(SELECTOR_BLOCK_NO_OFFERS);
			const withOffersBlock = document.querySelector(SELECTOR_BLOCK_WITH_OFFERS);

			if (noOffersBlock) {
				const parent = noOffersBlock.closest(SELECTOR_MOBILE_SECTION);
				if (parent) {
					parent.style.gridTemplateRows = `repeat(${NO_OFFERS_GRID_ROW_COUNT}, ${GRID_ROW_HEIGHT_PX}px)`;
				}
			}

			if (withOffersBlock) {
				const parent = withOffersBlock.closest(SELECTOR_MOBILE_SECTION);
				if (parent) {
					const rowCount = Math.round(this.triangleOffers.length / 2 + 1);
					parent.style.gridTemplateRows = `repeat(${rowCount}, ${GRID_ROW_HEIGHT_PX}px)`;
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.triangle-rewards-card {
	display: flex;
	flex-direction: column;
	background-color: #fff;
	width: inherit;
	height: inherit;
	/* calc(16em * 0.8235);*/
	text-rendering: optimizeLegibility;
	-webkit-font-smoothing: antialiased;
	z-index: 999;

	/*border: solid 1px #AEAEAE;*/
	.content {
		position: relative;
		display: flex;
		flex-direction: column;
		flex-basis: 100%;
		justify-content: center;
		align-items: center;
		text-align: left;
	}

	.rewards_signin {
		border: solid 1px #AEAEAE;

		.cta,
		.cta-title,
		.cta-content,
		.cta-body {
			display: flex;
			flex-direction: column;
			align-items: flex-end;
		}

		.cta {
			position: absolute;
			max-width: 55%;
			top: 12%;
			right: 6%;
			gap: 8px;
		}

		.fr .cta {
			top: 16%;
      gap: 0;
      right: 4%;
      max-width: 65%;
      text-align: right;
		}

    .fr.vertical.mobile .cta {
      top: 16%;
    }

		.cta-content {
			gap: 8px;
		}

		.cta-join {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-end;
			gap: 3px;

			a {
				color: #fff;
			}
		}

		.fr .cta-join {
			flex-direction: column;
		}

		h1 {
			color: #fff;
			font-size: 2.2em;
			line-height: 1.1;

			.registered-trademark {
				font-size: 0.3em;
				font-weight: 400;
				vertical-align: super;
			}
		}

    .vertical:not(.mobile) h1 {
      font-size: 2.6em;
      line-height: 1.2;
    }

    .vertical.mobile h1 {
      font-size: 1.4em;
    }

    .fr.vertical.mobile h1 {
      font-size: 1.3em;
    }

    h2 {
			color: #fff;
			font-size: 2em;
      line-height: 2;
		}

    .fr.vertical.mobile h2 {
      font-size: 1.1em;
      line-height: 1.8;
    }

    .fr .rewards_text_post_en {
      font-size: 0.9em;
      font-weight: 300;
      padding-top: 8px;
    }

    .fr .click_to_join {
      font-size: 0.8em;
      font-weight: 300;
    }

    .fr .click_to_join_en {
      font-size: 0.7em;
      font-weight: 300;
      padding-top: 8px;
    }

		.cta-button {
			border: none;
			background-color: #fff;
			color: #287d87;
			padding: 5px 20px 5px;
			font-size: 1.4em;
			font-weight: 600;
      border-radius: 1px;
		}

    .vertical:not(.mobile) .cta-button {
      padding: 15px 40px 15px;
      font-size: 1.4em;
    }

    .fr.vertical.mobile .cta-button {
      font-size: 0.9em;
    }

		img {
			width: 100%;
			height: auto;
		}

		p {
			color: #fff;
		}

    .vertical.mobile p {
      font-size: 0.9em;
    }

    .fr.vertical.mobile p {
      font-size: 0.63em;
    }
	}

	.logo {
		width: 100%;
	}
}
</style>

<style lang="scss">

[page-id='triangleRewards'].section-container {
  &>.flyer-block.TriangleRewardsCard.noOffers {
    overflow: hidden;
  }
}

[mode='mobile'] [page-id='triangleRewards'].section-container {
	position: relative;

	&>.flyer-block.TriangleRewardsCard {
		grid-area: span 1 / span 2 / auto / auto !important;

		&.noOffers,
		&.previewFlyer {
			grid-area: span 3 / span 2 / auto / auto !important;
		}
	}

	@-moz-document url-prefix() {
		.block.noOffers {
			position: absolute;
			bottom: 100%;
			transform: translateY(-300%);
		}
	}
}
</style>